import * as React from 'react';

// API
import apibridge from '../../../apibridge';

// REDUX
import { useAppDispatch, useAppSelector } from '../../../store';
import UserSlice from '../../../store/slices/User';

// PACKAGES
import { Link, useHistory } from 'react-router-dom';

// COMPONENTS
import Button from '../../../components/Button';

// ICONS
import { ReactComponent as TickIcon } from '../../../assets/svg/tick-circle.svg';
import { ReactComponent as LogOutIcon } from '../../../assets/svg/logout.svg';

// TYPES
interface CertificationSuccessTypes {
	organisationName?: string;
	newlyCreatedOrganisationId?: string;
	isActive?: boolean;
}

const CertificationSuccess: React.FC<CertificationSuccessTypes> = ({
	organisationName,
	newlyCreatedOrganisationId,
	isActive
}) => {
	const history = useHistory();

	const dispatch = useAppDispatch();

	const websiteURL = useAppSelector((store) => store.lists.websiteUrl);

	const hasMultipleProfiles = useAppSelector((store) => store.user.profiles && store.user.profiles.length > 0);

	const doLogout = () => {
		dispatch(UserSlice.actions.logOut());
	};

	const goToHomepage = () => {
		window.location.href = websiteURL || '';
	};

	const goToJoin = () => {
		history.push('/find-organisation');
	};

	const submit = async () => {
		if (isActive) {
			const response = await apibridge.doSwitchOrganisation({ profileId: newlyCreatedOrganisationId });

			if (response.isError) {
				console.log(response.validationErrors.map((error) => 'Error: ' + (error.name + ' - ' + error.reason)));
			} else {
				dispatch(UserSlice.actions.forceUpdate({}));

				history.push('/dashboard');
			}
		} else {
			dispatch(UserSlice.actions.forceUpdate({}));

			history.push('/dashboard');
		}
	};

	return (
		<div className="success-container">
			<TickIcon className="icon success-icon" />

			<span className="sub-grey-text">
				{newlyCreatedOrganisationId && isActive ? (
					<>Your new Organisation {organisationName} has been created</>
				) : (
					<>Your request to join {organisationName} has been sent and you will be notified when it has been reviewed.</>
				)}
			</span>

			{(newlyCreatedOrganisationId && isActive) || hasMultipleProfiles ? (
				<Button className="btn-primary submit-btn" onClick={submit}>
					Go to Dashboard
				</Button>
			) : (
				<section className="link-group">
					<Button className="btn btn-primary" onClick={() => goToHomepage()}>
						Return to homepage
					</Button>
					<Button className="btn btn-primary" onClick={() => goToJoin()}>
						Join another organisation
					</Button>
					<Button className="btn btn-primary" onClick={doLogout}>
						<LogOutIcon /> Logout
					</Button>
				</section>
			)}
		</div>
	);
};

export default CertificationSuccess;
